import { JSX } from "react";
import { formatEnumValue } from "./utility";
import { ProjectionProviderType, ProviderNetworkType } from "@app/projects/enumerators";

enum ProviderNetworkBadgeOption {
  Unknown = "unknown",
  Network = "network",
  Market = "market",
  Prospect = "prospect",
  Targeted = "targeted",
}

const convertToBadge = (type: ProviderNetworkType | ProjectionProviderType): ProviderNetworkBadgeOption => {
  switch (type) {
    case ProviderNetworkType.Network:
      return ProviderNetworkBadgeOption.Network;
    case ProviderNetworkType.Market:
      return ProviderNetworkBadgeOption.Market;
    case ProviderNetworkType.Prospect:
      return ProviderNetworkBadgeOption.Prospect;
    case ProjectionProviderType.Target:
      return ProviderNetworkBadgeOption.Targeted;
    default:
      return ProviderNetworkBadgeOption.Unknown;
  }
};

interface ProviderBadgeProps {
  providerNetworkType: ProviderNetworkType | ProjectionProviderType
}

const ProviderBadge = (props: ProviderBadgeProps): JSX.Element => {
  if (!props.providerNetworkType) {
    return;
  }
  const badgeType = convertToBadge(props.providerNetworkType);

  if (badgeType === ProviderNetworkBadgeOption.Unknown) {
    return;
  }
  return (
    <div className={`provider-type-badge provider-type-badge-${badgeType}`}>
      {formatEnumValue(badgeType)}
    </div>
  );
};

export default ProviderBadge;
